import { jsxs, jsx } from 'react/jsx-runtime';
import { ModalWrapper, ModalFooter, ModalPrimaryButton } from '@zooplus/ui-components';
import styles from './NewsletterConfirmModal.module.scss.js';

const NewsletterConfirmModal = ({ show, onClose, confirmationHeadline, confirmationText, confirmationButtonText, }) => {
    return (jsxs(ModalWrapper, { "data-zta": "success-subscription-modal", isShown: show, closeBtnAriaLabel: "Close", heading: confirmationHeadline, headingId: "newsletter-confirm-modal-heading", onClose: onClose, children: [jsx("div", { className: styles.newsletterModalText, dangerouslySetInnerHTML: {
                    __html: confirmationText,
                } }), jsx(ModalFooter, { children: jsx(ModalPrimaryButton, { "data-zta": "success-subscription-button", onClick: onClose, children: confirmationButtonText }) })] }));
};

export { NewsletterConfirmModal as default };
//# sourceMappingURL=NewsletterConfirmModal.js.map
